import { render, staticRenderFns } from "./SwiperBanner.vue?vue&type=template&id=4d0ff40e&scoped=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=js"
export * from "./SwiperBanner.vue?vue&type=script&lang=js"
import style0 from "./SwiperBanner.vue?vue&type=style&index=0&id=4d0ff40e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ff40e",
  null
  
)

export default component.exports